import { render } from "./index.vue?vue&type=template&id=927f9694&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=927f9694&lang=scss&scoped=true"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927f9694"],['__file',"src/app/program/views/file-manage/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "927f9694"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('927f9694', __exports__)) {
    console.log('reload')
    api.reload('927f9694', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=927f9694&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('927f9694', render)
  })

}


export default __exports__